<div class="festival-statistic">
    <pf-loading-overlay />
    <div class="festival-statistic__filters">
        <form
            action="statistics_filters"
            class="festival-statistic__filter-form"
            [formGroup]="productStatisticsFilter"
            (submit)="updateFestivalStatisticsByFilter()"
        >
            <div class="festival-statistic__filter-field">
                <label for="product-event-festivals">{{ 'admin.product.statistics.detail.festivalName' | translate }}:</label>
                <pf-select
                    [options]="festivalOptions"
                    [multiMode]="true"
                    [initialSelectedIds]="savedFestivalIds()"
                    (selectionChange)="onFestivalIdsChange($event)"
                />
            </div>
            <div class="festival-statistic__filter-field">
                <pf-datepicker
                    [multiMode]="true"
                    [initialStartDate]="savedStartDate()"
                    [initialEndDate]="savedEndDate()"
                    [maxDate]="maxDate"
                    (selectedStartDate)="onStartDateChange($event)"
                    (selectedEndDate)="onEndDateChange($event)"
                />
            </div>
            <div class="festival-statistic__filter-field festival-statistic__filter-actions">
                <button class="festival-statistic__search-btn" type="submit">
                    <mat-icon>search</mat-icon>
                    <span>{{ 'admin.product.statistics.button.search' | translate }}</span>
                </button>
                <button class="festival-statistic__reset-btn" type="button" (click)="onResetFilters()">
                    <mat-icon>refresh</mat-icon>
                    <span>{{ 'PRODUCT_EVENTS.RESET_FILTERS' | translate }}</span>
                </button>
            </div>
        </form>
    </div>
    @if (getFestivalStatisticResponse.festivalStatisticsList?.length) {
        @if (totalItems() > 0) {
            <pf-pagination
                [requestedPage]="page()"
                [requestedPageSize]="size()"
                [totalItems]="totalItems()"
                (pageChanged)="onPageChanged($event)"
            />
        }
        <div class="festival-statistic__grid-container">
            <div class="festival-statistic__grid">
                <div class="festival-statistic__grid-header">
                    <div class="festival-statistic__grid-column">{{ 'admin.product.statistics.festivalView.festivalName' | translate }}</div>
                    <div class="festival-statistic__grid-column">{{ 'admin.product.statistics.festivalView.movedOut' | translate }}</div>
                    <div class="festival-statistic__grid-column">{{ 'admin.product.statistics.festivalView.sold' | translate }}</div>
                    <div class="festival-statistic__grid-column">{{ 'admin.product.statistics.festivalView.returned' | translate }}</div>
                </div>
                <div class="festival-statistic__grid-body">
                    @for (statistic of getFestivalStatisticResponse.festivalStatisticsList; track $index; let i = $index) {
                        <div
                            class="festival-statistic__grid-row"
                            [class.festival-statistic__grid-row--clickable]="statistic.festivalProductDetailList?.length"
                            [class.festival-statistic__grid-row--selected]="selectedRowIndex() === i"
                            [tabindex]="statistic.festivalProductDetailList?.length ? 0 : -1"
                            (click)="statistic.festivalProductDetailList?.length ? selectRow(i) : null"
                            (keydown.enter)="statistic.festivalProductDetailList?.length ? selectRow(i) : null"
                        >
                            <div class="festival-statistic__grid-cell">{{ statistic.festivalName }}</div>
                            <div class="festival-statistic__grid-cell">{{ statistic.movedOutQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="festival-statistic__grid-cell">{{ statistic.soldQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                            <div class="festival-statistic__grid-cell">{{ statistic.returnedQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                        </div>
                        @if (statistic.expanded && statistic.festivalProductDetailList?.length) {
                            <div class="festival-statistic__expanded" tabindex="0">
                                @if (statistic.festivalProductDetailList) {
                                    <div class="festival-statistic__product-details">
                                        <div class="festival-statistic__expanded-title">
                                            <mat-icon>library_books</mat-icon>
                                            <span>{{ 'admin.product.statistics.detail.perProductTitle' | translate }}</span>
                                        </div>
                                        <div class="festival-statistic__grid">
                                            <div class="festival-statistic__grid-header">
                                                <div class="festival-statistic__grid-column">
                                                    {{ 'admin.product.statistics.field.productName' | translate }}
                                                </div>
                                                <div class="festival-statistic__grid-column">
                                                    {{ 'admin.product.statistics.festivalView.movedOut' | translate }}
                                                </div>
                                                <div class="festival-statistic__grid-column">
                                                    {{ 'admin.product.statistics.festivalView.sold' | translate }}
                                                </div>
                                                <div class="festival-statistic__grid-column">
                                                    {{ 'admin.product.statistics.festivalView.returned' | translate }}
                                                </div>
                                            </div>
                                            <div class="festival-statistic__grid-body">
                                                @for (detail of statistic.festivalProductDetailList; track $index) {
                                                    <div class="festival-statistic__grid-row festival-statistic__grid-row--detail">
                                                        <div class="festival-statistic__grid-cell">{{ detail.productName }}</div>
                                                        <div class="festival-statistic__grid-cell">
                                                            {{ detail.movedOutQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                        <div class="festival-statistic__grid-cell">{{ detail.soldQuantity | number: '1.0-0' : 'hu-HU' }}</div>
                                                        <div class="festival-statistic__grid-cell">
                                                            {{ detail.returnedQuantity | number: '1.0-0' : 'hu-HU' }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
        @if (totalItems() > 0) {
            <pf-pagination
                [requestedPage]="page()"
                [requestedPageSize]="size()"
                [totalItems]="totalItems()"
                (pageChanged)="onPageChanged($event)"
            />
        }
        <div class="festival-statistic__totals">
            <div class="festival-statistic__total-card">
                <mat-icon>outbox</mat-icon>
                <span>{{ 'admin.product.statistics.festivalView.totalMovedOut' | translate | uppercase }}</span>
                <div class="festival-statistic__total-value">{{ totals()?.movedOut | number: '1.0-0' : 'hu-HU' }}</div>
            </div>
            <div class="festival-statistic__total-card">
                <mat-icon>shopping_cart</mat-icon>
                <span>{{ 'admin.product.statistics.festivalView.totalSold' | translate | uppercase }}</span>
                <div class="festival-statistic__total-value">{{ totals()?.sold | number: '1.0-0' : 'hu-HU' }}</div>
            </div>
            <div class="festival-statistic__total-card">
                <mat-icon>arrow_circle_left</mat-icon>
                <span>{{ 'admin.product.statistics.festivalView.totalReturned' | translate | uppercase }}</span>
                <div class="festival-statistic__total-value">{{ totals()?.returned | number: '1.0-0' : 'hu-HU' }}</div>
            </div>
        </div>
    }
</div>
